import { createBrowserHistory } from 'history';

export type LocationState = { unhijack?: boolean };
// create history manually so it can be user outside components
// rationale: https://github.com/ReactTraining/react-router/issues/4727
export default createBrowserHistory<LocationState>();
